export default __webpack_public_path__ + "static/media/bad3361ef1e3546d-.74c479ab.gif";